module.exports = __webpack_public_path__ + "img/sea-418742.05196c01.jpg";